// extracted by mini-css-extract-plugin
export default {"hybridTable":"yUsRdfVRZ5WMfORZpbDS","column":"LEzdCR7CDkJljb5tMxEF"};